import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { avatarDriverFactory } from './Avatar.driver';
import { Avatar } from '.';

describe('Avatar', () => {
  const createDriver = createRendererWithUniDriver(avatarDriverFactory);

  it('should render', async () => {
    const { driver } = createDriver(<Avatar />);
    expect(await driver.exists()).toBe(true);
  });

  it('should render an empty placeholder by default', async () => {
    const { driver } = createDriver(<Avatar />);
    expect((await driver.getContentType()) === 'placeholder').toBe(true);
  });

  it('should render single initial', async () => {
    const { driver } = createDriver(<Avatar name="John Doe" />);
    expect(await driver.getTextContent()).toBe('J');
  });

  describe(`content type resolution`, () => {
    it('should render a text when name given', async () => {
      const { driver } = createDriver(<Avatar name="John Doe" />);
      expect((await driver.getContentType()) === 'text').toBe(true);
    });
    it('should render a placeholder', async () => {
      const { driver } = createDriver(<Avatar />);
      expect((await driver.getContentType()) === 'placeholder').toBe(true);
    });
  });
});
